import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from '@/app/App'
import { loadConfig } from '@/lib/env/config'

import './styles.css'

const container = document.getElementById('root')
if (container === null) throw new Error('missing #root container')

const root = createRoot(container)

/**
 * CLAUDE.md Part I §4 — the console refuses to start without valid runtime
 * configuration. We render the reason rather than a blank page, because the
 * person who sees this is an operator or a deployer, and they need the fix.
 */
try {
  const config = loadConfig()
  root.render(
    <StrictMode>
      <BrowserRouter>
        <App config={config} />
      </BrowserRouter>
    </StrictMode>,
  )
} catch (error) {
  root.render(
    <main className="startup-failure" role="alert">
      <h1>Operator console cannot start</h1>
      <p>{error instanceof Error ? error.message : String(error)}</p>
    </main>,
  )
}
